export const SLOT_STYLES = {
  1: {
    border: '2px solid #378ADD',
    background: '#E6F1FB',
    nameColor: '#0C447C',
    pip: { background: '#378ADD', color: '#E6F1FB' }
  },
  2: {
    border: '2px solid #D85A30',
    background: '#FAECE7',
    nameColor: '#712B13',
    pip: { background: '#D85A30', color: '#FAECE7' }
  }
} as const;
